import { i18n } from "@/plugins/i18n";

export class Investor {
  columns = [];
  id = "id";

  fillAbles = [
    ["name", i18n.t("name"), true],
    ["invoiceNumber", i18n.t("invoiceNumber"), true],
    ["meter", i18n.t("meter"), true],
    ["mcPaidPrice", i18n.t("paidPrice"), true],
    ["mcNeedToPay", i18n.t("needToPay"), true],
    ["ratio", i18n.t("ratio"), true, false],
    ["addToSafeBox", i18n.t("addToSafeBox"), true, false],
    ["date", i18n.t("date"), true],
    ["note", i18n.t("note"), true, false],
    ["attachment", i18n.t("attachment"), true, false],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
